import { Loading } from "components/shared";
import React, { useEffect } from "react";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";


const AddQuote = (props) => {

    const { run, input, writeBackInsert, closeMenu } = useMagicAction(props);

    useEffect(() => {
        run({
            prompt: input
                ? `Provide one real, attributable quote relevant to the following text, formatted as: "quote" — Author. Return only the quote.\n\nTEXT:\n${input}`
                : `Provide one real, attributable quote relevant to the company, formatted as: "quote" — Author. Return only the quote.`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackInsert(asText(r)))
            .finally(closeMenu);
    }, []);

    return (
        <div className="flex flex-col items-center justify-center gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default AddQuote;
